import { Component, OnInit, ElementRef, OnDestroy } from "@angular/core";
import { ROUTES } from "../sidebar/sidebar.component";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from "../../services/authentication/auth.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "app-auth-navbar",
  templateUrl: "./auth-navbar.component.html",
  styleUrls: ["./auth-navbar.component.css"]
})
export class AuthNavbarComponent implements OnInit, OnDestroy {

  selectedLang = 'ro';

  languageList = [{code: 'ro', display: 'RO'}, {code: 'en', display: 'EN'}];

  constructor(private authService: AuthService,
              private translateService: TranslateService,
              private router: Router) {}

  ngOnInit() {
    const lang = localStorage.getItem('lang');
    if (lang) {
      this.selectedLang = lang;
    }
  }

  ngOnDestroy() {
  }

  languageChange() {
    this.translateService.use(this.selectedLang);
    localStorage.setItem('lang', this.selectedLang);
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  goHome() {
    this.router.navigate(["/"]);
  }
}
